/* Půjčovna — termín, kalkulačka a poptávka s VÍCE STROJI (Triumph 6. 10. 2026, pak KTM).
   Port Emota (`emoto-pujcovna-kalk.js`, 1. 10.) + Lukášův blok „Motorky v poptávce“ z pujcovnavlasim.cz
   (motorka.html: MB[], otevriVyber(), .mbk). Mechanika i ceny 1:1 podle Lukáše:
   - den / víkend (pá–po) / více dní, sleva z nájmu strojů 3–4 dny −10 %, 5–7 −15 %, 8+ −20 %
   - výstroj se počítá na počet dní, u víkendu na 3 dny; všech 8 kusů = set (výhodnější)
   - set pro další jezdce: u prvního stroje ×(kusů − 1), u dalších strojů × kusů
   - vozík 800/den, víkend 2 000, přidává 5 000 ke kauci; kufry jen u strojů s kufry
   - kauce = součet kaucí strojů × kusy
   - vyzvednutí i vrácení jen v pracovní den (So/Ne, svátky a zavřeno nejdou vybrat)
   Data (stroje, ceník, nastavení) jsou v JSON bloku #pj-data — sekce ho skládá z metaobjektů
   „Stroj půjčovny“ a „Ceník půjčovny“. V JS není žádná cena natvrdo.
   ⚠ Soubor je stejný na Triumphu i KTM — liší se jen sekce (Liquid) a CSS. */
(function () {
  var koren = document.getElementById('pj-kalk');
  var dataEl = document.getElementById('pj-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  /* ⚠ bez strojů (metaobjekty chybí / všechny v konceptu) kalkulačka běží dál — výstroj, termín i vozík se počítají */
  var STROJE = (D.stroje || []).filter(function (s) { return s && s.id && +s.d > 0; });
  var SEKCE = D.sekce || [];
  var VYSTROJ = D.vystroj || [];
  var DOPLNKY = D.doplnky || [];
  var MAXKS = +D.maxKs || 6, MAXDNI = +D.maxDni || 30;

  function stroj(id) { for (var i = 0; i < STROJE.length; i++) { if (STROJE[i].id === id) return STROJE[i]; } return null; }
  function doplnek(id) { for (var i = 0; i < DOPLNKY.length; i++) { if (DOPLNKY[i].id === id) return DOPLNKY[i]; } return null; }
  function cenaKusu(id) { for (var i = 0; i < VYSTROJ.length; i++) { if (VYSTROJ[i].id === id) return +VYSTROJ[i].p || 0; } return 0; }
  function nazevKusu(id) { for (var i = 0; i < VYSTROJ.length; i++) { if (VYSTROJ[i].id === id) return VYSTROJ[i].n; } return id; }
  function kc(n) { return Math.round(n).toLocaleString('cs-CZ'); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function dnyTxt(n) { return n + ' ' + (n === 1 ? 'den' : n < 5 ? 'dny' : 'dní'); }
  var SETP = cenaKusu('set') || 600;

  /* slevy „3:10, 5:15, 8:20" */
  var slevy = String(D.slevy || '').split(',').map(function (t) { var x = t.trim().split(':'); return { od: +x[0], pct: +x[1] }; })
    .filter(function (x) { return x.od > 0 && x.pct > 0; }).sort(function (a, b) { return b.od - a.od; });
  function sleva(n) { for (var i = 0; i < slevy.length; i++) { if (n >= slevy[i].od) return slevy[i].pct / 100; } return 0; }
  /* hodiny „9:00-12:00, 13:00-17:00" */
  var HOD = { dop: [540, 720], odp: [780, 1020] };
  var hh = String(D.hodiny || '').split(',').map(function (t) { return t.trim().split('-').map(function (v) { var m = v.match(/(\d{1,2})[:.](\d{2})/); return m ? (+m[1]) * 60 + (+m[2]) : null; }); });
  if (hh[0] && hh[0][0] != null && hh[0][1] != null) HOD.dop = hh[0];
  if (hh[1] && hh[1][0] != null && hh[1][1] != null) HOD.odp = hh[1];
  /* zavřeno: řádek „RRRR-MM-DD" nebo „RRRR-MM-DD..RRRR-MM-DD" */
  var ZAVRENO = String(D.zavreno || '').split(/\r?\n/).map(function (t) { var x = t.trim().split('..'); return x[0] ? { od: x[0].trim(), do: (x[1] || x[0]).trim() } : null; }).filter(Boolean);

  /* ---------- pracovní dny: So/Ne, státní svátky, zavřeno ---------- */
  function velikonocniNedele(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
      m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31),
      da = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, mo - 1, da);
  }
  var SVATKY = ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26'];
  function jeSvatek(d) {
    var md = (d.getUTCMonth() + 1) + '-' + d.getUTCDate();
    if (SVATKY.indexOf(md) >= 0) return true;
    var vn = velikonocniNedele(d.getUTCFullYear()), t = d.getTime();
    return t === vn - 2 * 864e5 || t === vn + 864e5;
  }
  function jeZavreno(d) {
    var isoD = d.toISOString().slice(0, 10);
    return ZAVRENO.some(function (z) { return z && z.od && isoD >= z.od && isoD <= (z.do || z.od); });
  }
  function jePracovni(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5 && !jeSvatek(d) && !jeZavreno(d); }
  function naDatum(v) { var x = String(v || '').split('-').map(Number); return x.length === 3 ? new Date(Date.UTC(x[0], x[1] - 1, x[2])) : null; }
  function pracovni(v) { var d = naDatum(v); return !!d && jePracovni(d); }
  function svatek(v) { var d = naDatum(v); return !!d && jeSvatek(d); }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function plusDny(v, n) { var x = v.split('-').map(Number); return iso(new Date(x[0], x[1] - 1, x[2] + n)); }
  var DNY_K = ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'];
  function fmtD(v) {
    var x = String(v || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!x) return '';
    var d = new Date(+x[1], +x[2] - 1, +x[3]);
    return DNY_K[d.getDay()] + ' ' + (+x[3]) + '. ' + (+x[2]) + '.';
  }

  /* ---------- stav otevírací doby ---------- */
  function prahaNyni() {
    var p = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    function g(t) { return parseInt(p.find(function (x) { return x.type === t; }).value, 10); }
    return { den: new Date(Date.UTC(g('year'), g('month') - 1, g('day'))), min: (g('hour') % 24) * 60 + g('minute'), mesic: g('month') };
  }
  function hhmm(m) { return Math.floor(m / 60) + ':' + String(m % 60).padStart(2, '0'); }
  var DNY_V = ['v neděli', 'v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu'];
  function stavOtevreno() {
    var n = prahaNyni(), Dp = HOD.dop, O = HOD.odp;
    if (jePracovni(n.den)) {
      if (n.min >= Dp[0] && n.min < Dp[1]) return { open: true, t: 'Právě máme otevřeno, do ' + hhmm(Dp[1]) };
      if (n.min >= O[0] && n.min < O[1]) return { open: true, t: 'Právě máme otevřeno, do ' + hhmm(O[1]) };
      if (n.min >= Dp[1] && n.min < O[0]) return { open: false, t: 'Polední pauza, volejte od ' + hhmm(O[0]) };
      if (n.min < Dp[0]) return { open: false, t: 'Otevíráme dnes v ' + hhmm(Dp[0]) };
    }
    var d = new Date(n.den.getTime() + 864e5), krok = 1;
    while (!jePracovni(d) && krok++ < 40) d = new Date(d.getTime() + 864e5);
    var kdy = krok === 1 ? 'zítra' : krok > 6 ? d.getUTCDate() + '. ' + (d.getUTCMonth() + 1) + '.' : DNY_V[d.getUTCDay()];
    return { open: false, t: 'Zavřeno, volejte ' + kdy + ' od ' + hhmm(Dp[0]) };
  }
  function vykresliStav() {
    var s = stavOtevreno();
    [].forEach.call(document.querySelectorAll('[data-open]'), function (el) {
      el.textContent = s.t;
      el.classList.toggle('je-otevreno', s.open);
      el.classList.toggle('je-zavreno', !s.open);
    });
  }
  vykresliStav();
  setInterval(vykresliStav, 60000);

  /* ---------- mimo sezónu (silniční stroje, XI–III) — jako Lukáš: kalendář neblokuje, jen věta ---------- */
  (function () {
    var m = prahaNyni().mesic;
    if (m >= 11 || m <= 3) {
      [].forEach.call(document.querySelectorAll('[data-pj-sezona]'), function (el) {
        el.insertAdjacentHTML('afterbegin', '<b>Teď je mimo sezónu.</b> ');
      });
    }
  })();

  /* stránka bez kalkulačky (KTM: flotila) — stačil stav otevírací doby a „mimo sezónu“ */
  if (!koren) return;

  /* ---------- motorky v poptávce: první je ta vybraná nahoře (karta), další si člověk přidá ---------- */
  var MB = [];
  (function () {
    var z = '';
    try { z = new URLSearchParams(location.search).get('m') || ''; } catch (e) { /* starý prohlížeč */ }
    var prvni = stroj(z) ? z : (stroj(D.prvni) ? D.prvni : (STROJE[0] || {}).id);
    if (prvni) MB.push({ id: prvni, ks: 1, set: false });
  })();
  var mbkEl = document.getElementById('pj-mbk');
  var fMotoEl = document.getElementById('pj-f-moto');
  function mbStroje() { return MB.map(function (r, i) { return { r: r, i: i, b: stroj(r.id) }; }).filter(function (x) { return x.b; }); }
  function mbText() { return mbStroje().map(function (x) { return x.b.n + (x.r.ks > 1 ? ' ×' + x.r.ks : ''); }).join(' + '); }
  function foto(b, w) { return b.img ? '<img src="' + esc(b.img) + '" alt="" loading="lazy" width="' + (w || 120) + '">' : ''; }
  function kresliMB() {
    mbkEl.innerHTML = mbStroje().map(function (x) {
      var r = x.r, i = x.i, b = x.b;
      var setLbl = (i > 0 || r.ks > 1) ? '<label class="pj-mbk__set"><input type="checkbox" data-a="set"' + (r.set ? ' checked' : '') + '> set výstroje ' +
        (i ? (r.ks > 1 ? 'ke každé' : 'k ní') : 'i pro další jezdce') + ' <em>' + kc(SETP) + ' Kč/den</em></label>' : '';
      return '<div class="pj-mbk__row" data-i="' + i + '">' +
        '<div class="pj-mbk__ph">' + foto(b, 120) + '</div>' +
        '<div class="pj-mbk__n"><b>' + esc(b.n) + '</b><small>' + kc(b.d) + ' Kč/den · kauce ' + kc(b.k) + ' Kč</small>' + setLbl + '</div>' +
        '<div class="pj-mbk__ks" aria-label="Počet kusů"><button type="button" data-a="minus" aria-label="Méně"' + (r.ks <= 1 ? ' disabled' : '') + '>−</button>' +
        '<span>' + r.ks + ' ks</span><button type="button" data-a="plus" aria-label="Více"' + (r.ks >= MAXKS ? ' disabled' : '') + '>+</button></div>' +
        (i ? '<button type="button" class="pj-mbk__x" data-a="del" aria-label="Odebrat ' + esc(b.n) + '">×</button>' : '<span class="pj-mbk__x"></span>') +
        '</div>';
    }).join('');
    if (fMotoEl) fMotoEl.innerHTML = mbStroje().map(function (x) {
      return '<div><b>' + esc(x.b.n) + '</b>' + (x.r.ks > 1 ? ' ×' + x.r.ks : '') + (x.r.set ? ' <span class="pj-slabe">+ set výstroje</span>' : '') + '</div>';
    }).join('');
  }
  mbkEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-a]');
    if (!b || b.dataset.a === 'set') return;
    var i = +b.closest('.pj-mbk__row').dataset.i, r = MB[i];
    if (!r) return;
    if (b.dataset.a === 'plus') r.ks = Math.min(MAXKS, r.ks + 1);
    if (b.dataset.a === 'minus') r.ks = Math.max(1, r.ks - 1);
    if (b.dataset.a === 'del' && i > 0) MB.splice(i, 1);
    if (i === 0 && r.ks === 1) r.set = false;
    prepocti();
  });
  mbkEl.addEventListener('change', function (e) {
    var c = e.target.closest('[data-a="set"]');
    if (!c) return;
    var r = MB[+c.closest('.pj-mbk__row').dataset.i];
    if (r) r.set = c.checked;
    prepocti();
  });

  /* ---------- výběr stroje nahoře (karta) — Triumph: jedna stránka, víc strojů ---------- */
  var dlazdice = document.querySelectorAll('[data-pj-vyber]');
  function ukazKartu(id) {
    [].forEach.call(document.querySelectorAll('[data-pj-detail]'), function (el) { el.hidden = el.dataset.pjDetail !== id; });
    [].forEach.call(dlazdice, function (el) {
      var on = el.dataset.pjVyber === id;
      el.classList.toggle('je-on', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function vyberPrvni(id) {
    if (!stroj(id)) return;
    var j = -1;
    for (var i = 0; i < MB.length; i++) { if (MB[i].id === id) j = i; }
    if (j > 0) MB.unshift(MB.splice(j, 1)[0]);
    else if (j < 0) MB[0] = MB[0] ? { id: id, ks: MB[0].ks, set: MB[0].set } : { id: id, ks: 1, set: false };
    if (MB[0].ks === 1) MB[0].set = false;
    ukazKartu(id);
    if (dlazdice.length) {
      try { var u = new URL(location.href); u.searchParams.set('m', id); history.replaceState(null, '', u.toString()); } catch (e) { /* nic */ }
    }
    prepocti();
  }
  [].forEach.call(dlazdice, function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      vyberPrvni(el.dataset.pjVyber);
      /* na mobilu je karta až pod všemi dlaždicemi — dojet na ni, ať je vidět, co se změnilo */
      var karta = document.querySelector('.pj-karta[data-pj-detail="' + el.dataset.pjVyber + '"]');
      if (karta && matchMedia('(max-width: 749px)').matches) karta.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
  });
  if (MB[0]) ukazKartu(MB[0].id);

  /* ---------- dialog „Přidat další motorku“ ---------- */
  var vyber = document.createElement('div');
  vyber.className = 'pj-pick';
  vyber.hidden = true;
  var sekceSeStroji = SEKCE.filter(function (sec) { return STROJE.some(function (b) { return b.s === sec.id; }); });
  if (!sekceSeStroji.length) sekceSeStroji = [{ id: '', t: '' }];
  vyber.innerHTML = '<div class="pj-pick__box" role="dialog" aria-modal="true" aria-label="Přidat motorku">' +
    '<button type="button" class="pj-pick__x" aria-label="Zavřít">×</button><h3>Přidat další motorku</h3>' +
    '<p>Termín a délka půjčení jsou pro všechny stroje stejné.</p>' +
    sekceSeStroji.map(function (sec) {
      var seznam = STROJE.filter(function (b) { return !sec.id || b.s === sec.id; });
      return '<div class="pj-pick__sec">' + (sec.t ? '<b>' + esc(sec.t) + '</b>' : '') + '<div class="pj-pick__list">' + seznam.map(function (b) {
        return '<button type="button" data-id="' + esc(b.id) + '"><span class="pj-mbk__ph">' + foto(b, 120) + '</span>' +
          '<span><b>' + esc(b.n) + '</b><small>' + kc(b.d) + ' Kč/den</small></span></button>';
      }).join('') + '</div></div>';
    }).join('') + '</div>';
  document.body.appendChild(vyber);
  if (!STROJE.length) [].forEach.call(document.querySelectorAll('[data-pj-pridat]'), function (b) { b.hidden = true; });
  function otevriVyber() { vyber.hidden = false; document.body.style.overflow = 'hidden'; var x = vyber.querySelector('.pj-pick__x'); if (x) x.focus(); }
  function zavriVyber() { vyber.hidden = true; document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pj-pridat]')) { e.preventDefault(); otevriVyber(); }
  });
  vyber.addEventListener('click', function (e) {
    if (e.target === vyber || e.target.closest('.pj-pick__x')) { zavriVyber(); return; }
    var b = e.target.closest('[data-id]');
    if (!b) return;
    var r = null;
    for (var i = 0; i < MB.length; i++) { if (MB[i].id === b.dataset.id) r = MB[i]; }
    if (r) r.ks = Math.min(MAXKS, r.ks + 1); else MB.push({ id: b.dataset.id, ks: 1, set: false });
    zavriVyber();
    prepocti();
    var t = mbkEl.querySelector('.pj-mbk__row:last-child');
    if (t) { t.classList.add('je-novy'); setTimeout(function () { t.classList.remove('je-novy'); }, 1200); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !vyber.hidden) zavriVyber(); });

  /* ---------- jezdec s výstrojí ---------- */
  var GL = ['bryle', 'dres', 'rukavice', 'kalhoty'], GR = ['helma', 'hrudni', 'kolena', 'boty'];
  var GALL = GL.concat(GR);
  var vybrano = [];
  var gearEl = document.getElementById('pj-gear');
  function gearKresliPolozky() {
    function polozka(id) {
      return '<button type="button" class="pj-gear__it" data-g="' + id + '" aria-pressed="false">' +
        '<span class="pj-gear__txt"><b>' + esc(nazevKusu(id)) + '</b><em>' + kc(cenaKusu(id)) + ' Kč</em></span>' +
        '<span class="pj-gear__tile">' + (GALL.indexOf(id) + 1) + '</span>' +
        '<i class="pj-gear__ln" aria-hidden="true"></i></button>';
    }
    gearEl.querySelector('.pj-gear__col--l').innerHTML = GL.map(polozka).join('');
    gearEl.querySelector('.pj-gear__col--r').innerHTML = GR.map(polozka).join('');
  }
  function gearPrekresli() {
    [].forEach.call(gearEl.querySelectorAll('[data-g]'), function (el) {
      var on = vybrano.indexOf(el.dataset.g) >= 0;
      el.classList.toggle('je-on', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function cenaVystroje() {
    var jednotlive = vybrano.reduce(function (s, id) { return s + cenaKusu(id); }, 0);
    var celySet = GALL.every(function (id) { return vybrano.indexOf(id) >= 0; });
    return { jednotlive: jednotlive, celySet: celySet, zaDen: celySet ? SETP : jednotlive, set: SETP };
  }
  gearKresliPolozky();
  gearEl.addEventListener('click', function (e) {
    var t = e.target.closest('[data-g]');
    if (!t) return;
    var id = t.dataset.g, i = vybrano.indexOf(id);
    if (i >= 0) vybrano.splice(i, 1); else vybrano.push(id);
    gearPrekresli(); prepocti();
  });
  function zvyrazni(id, on) { [].forEach.call(gearEl.querySelectorAll('[data-g="' + id + '"]'), function (el) { el.classList.toggle('je-hl', on); }); }
  gearEl.addEventListener('mouseover', function (e) { var t = e.target.closest('[data-g]'); if (t) zvyrazni(t.dataset.g, true); });
  gearEl.addEventListener('mouseout', function (e) { var t = e.target.closest('[data-g]'); if (t) zvyrazni(t.dataset.g, false); });
  document.getElementById('pj-gear-set').addEventListener('click', function () { vybrano = GALL.slice(); gearPrekresli(); prepocti(); });
  document.getElementById('pj-gear-zrus').addEventListener('click', function () { vybrano = []; gearPrekresli(); prepocti(); });

  /* ---------- délka a termín ---------- */
  var polOd = document.getElementById('pj-od'), polDo = document.getElementById('pj-do');
  var dnyEl = document.getElementById('pj-dny');
  function delka() { return (koren.querySelector('input[name="pj-len"]:checked') || {}).value || 'den'; }
  function zaskrtni(v) { var x = koren.querySelector('input[name="pj-len"][value="' + v + '"]'); if (x) x.checked = true; }
  function pocetDni() {
    var d = delka();
    if (d === 'den') return 1;
    if (d === 'vikend') return 3;
    return Math.max(2, Math.min(MAXDNI, parseInt(dnyEl.value, 10) || 2));
  }
  function terminChyby() {
    var h = [], a = polOd.value, b = polDo.value, dnes = iso(new Date());
    if (a && a < dnes) h.push('Vyzvednutí je v minulosti, vyberte prosím jiný den.');
    if (a && !pracovni(a)) h.push('V tento den stroje nevydáváme (víkend, svátek nebo máme zavřeno). Víkendové půjčení: vyzvednutí v pátek 9–17, vrácení v pondělí do 10:00.');
    if (b && !pracovni(b)) h.push('Vracet se dá jen v pracovní den, u víkendu v pondělí do 10:00.');
    if (a && b && b <= a) h.push('Vrácení musí být až po vyzvednutí.');
    return h;
  }
  function vykresliTermin() {
    var h = terminChyby(), el = document.getElementById('pj-kalk-hint');
    el.innerHTML = h.join('<br>');
    el.classList.toggle('je-chyba', h.length > 0);
    [].forEach.call(koren.querySelectorAll('.pj-dbtn'), function (b) {
      var v = document.getElementById('pj-' + b.dataset.for).value;
      b.innerHTML = v ? '<b>' + fmtD(v).slice(0, 2) + '</b> ' + (+v.slice(8)) + '. ' + (+v.slice(5, 7)) + '. ' + v.slice(0, 4) : '<span>vyberte den</span>';
      b.classList.toggle('je-chyba', !!v && h.length > 0 && (!pracovni(v) || (b.dataset.for === 'do' && v <= polOd.value)));
    });
  }
  function dopocitejVraceni() {
    var a = polOd.value;
    if (!a) return;
    var d = delka(), od = a;
    if (d === 'vikend') {
      var x = a.split('-').map(Number), den = new Date(x[0], x[1] - 1, x[2]);
      od = plusDny(a, (5 - den.getDay() + 7) % 7);
      polOd.value = od;
    }
    var n = pocetDni(), cil = plusDny(od, n), v = cil, k = 0;
    while (!pracovni(v) && k++ < 14) v = plusDny(v, 1);
    polDo.value = v;
    vykresliTermin();
    if (v !== cil) srovnejDelku();
  }
  function srovnejDelku() {
    var a = polOd.value, b = polDo.value;
    if (!a || !b) return;
    var d1 = new Date(a), d2 = new Date(b), n = Math.round((d2 - d1) / 864e5);
    if (n < 1) return;
    if (d1.getDay() === 5 && d2.getDay() === 1 && n === 3) zaskrtni('vikend');
    else if (n === 1) zaskrtni('den');
    else { zaskrtni('vice'); dnyEl.value = n; }
  }
  [].forEach.call(koren.querySelectorAll('input[name="pj-len"]'), function (i) {
    i.addEventListener('change', function () { dopocitejVraceni(); prepocti(); });
  });
  dnyEl.addEventListener('input', function () { zaskrtni('vice'); dopocitejVraceni(); prepocti(); });
  dnyEl.addEventListener('focus', function () { zaskrtni('vice'); prepocti(); });
  polOd.addEventListener('change', function () {
    if (polOd.value && (!polDo.value || polDo.value <= polOd.value)) dopocitejVraceni();
    vykresliTermin(); srovnejDelku(); prepocti();
  });
  polDo.addEventListener('change', function () { vykresliTermin(); srovnejDelku(); prepocti(); });

  /* ---------- kalendář ---------- */
  var MES = ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'];
  var cal = document.createElement('div');
  cal.className = 'pj-cal';
  cal.hidden = true;
  cal.setAttribute('role', 'dialog');
  cal.setAttribute('aria-label', 'Výběr dne');
  document.body.appendChild(cal);
  var calPole = null, calMes = null, bubTimer = null;

  function calDuvod(v, dnes) {
    var co = calPole === 'od' ? 'vyzvednout' : 'vracet';
    if (v < dnes) return 'Tento den už je pryč';
    var x = v.split('-').map(Number), wd = new Date(x[0], x[1] - 1, x[2]).getDay();
    if (wd === 0 || wd === 6 || svatek(v)) return 'Soboty, neděle a svátky nelze motocykl ' + co;
    if (!pracovni(v)) return 'V tento den máme zavřeno, motocykl nelze ' + co;
    if (calPole === 'do' && polOd.value && v <= polOd.value) return 'Vrácení musí být až po vyzvednutí';
    return '';
  }
  function calKresli() {
    var dnes = iso(new Date()), od = polOd.value, doo = polDo.value, sel = document.getElementById('pj-' + calPole).value;
    var y = calMes.getFullYear(), mo = calMes.getMonth();
    var posun = (new Date(y, mo, 1).getDay() + 6) % 7, pocet = new Date(y, mo + 1, 0).getDate();
    var ted = new Date();
    var h = '<div class="pj-cal__top"><button type="button" data-k="-1" aria-label="Předchozí měsíc"' +
      (new Date(y, mo, 1) <= new Date(ted.getFullYear(), ted.getMonth(), 1) ? ' disabled' : '') + '>&lsaquo;</button>' +
      '<b>' + MES[mo] + ' ' + y + '</b>' +
      '<button type="button" data-k="1" aria-label="Další měsíc">&rsaquo;</button></div>';
    h += '<div class="pj-cal__co">' + (calPole === 'od' ? 'Vyzvednutí' : 'Vrácení') + '</div><div class="pj-cal__g">';
    h += ['po', 'út', 'st', 'čt', 'pá', 'so', 'ne'].map(function (d) { return '<i>' + d + '</i>'; }).join('');
    for (var i = 0; i < posun; i++) h += '<span></span>';
    for (var d = 1; d <= pocet; d++) {
      var v = iso(new Date(y, mo, d)), duvod = calDuvod(v, dnes), zak = !!duvod;
      var cls = [zak ? 'je-off' : '', v === sel ? 'je-sel' : '',
        (od && doo && v > od && v < doo) ? 'je-in' : '',
        ((v === od || v === doo) && v !== sel) ? 'je-kraj' : '',
        v === dnes ? 'je-dnes' : ''].filter(Boolean).join(' ');
      h += '<button type="button" data-v="' + v + '" class="' + cls + '"' +
        (zak ? ' aria-disabled="true" data-duvod="' + duvod + '"' : '') + '>' + d + '</button>';
    }
    h += '</div><div class="pj-cal__bub" hidden></div>' +
      '<div class="pj-cal__pata">Vyzvednutí i vrácení jen v pracovní dny. Víkend: pátek až pondělí.</div>';
    cal.innerHTML = h;
  }
  function calBublina(btn) {
    var b = cal.querySelector('.pj-cal__bub');
    if (!b) return;
    b.textContent = btn.dataset.duvod;
    b.hidden = false;
    var r = btn.getBoundingClientRect(), k = cal.getBoundingClientRect();
    var w = b.offsetWidth, left = Math.max(6, Math.min(r.left - k.left + r.width / 2 - w / 2, k.width - w - 6));
    b.style.left = left + 'px';
    b.style.top = (r.top - k.top - b.offsetHeight - 8) + 'px';
    b.style.setProperty('--sipka', (r.left - k.left + r.width / 2 - left) + 'px');
    btn.classList.add('je-bump');
    setTimeout(function () { btn.classList.remove('je-bump'); }, 350);
    clearTimeout(bubTimer);
    bubTimer = setTimeout(function () { b.hidden = true; }, 2800);
  }
  function calOtevri(btn) {
    calPole = btn.dataset.for;
    var v = document.getElementById('pj-' + calPole).value || (calPole === 'do' && polOd.value) || iso(new Date());
    var x = v.split('-').map(Number);
    calMes = new Date(x[0], x[1] - 1, 1);
    calKresli();
    cal.hidden = false;
    if (matchMedia('(max-width: 749px)').matches) { cal.style.left = ''; cal.style.top = ''; }
    else {
      var r = btn.getBoundingClientRect();
      cal.style.left = Math.min(r.left + scrollX, scrollX + innerWidth - cal.offsetWidth - 12) + 'px';
      cal.style.top = (r.bottom + scrollY + 6) + 'px';
    }
    [].forEach.call(koren.querySelectorAll('.pj-dbtn'), function (b) { b.classList.toggle('je-open', b === btn); });
  }
  function calZavri() {
    cal.hidden = true;
    [].forEach.call(koren.querySelectorAll('.pj-dbtn'), function (b) { b.classList.remove('je-open'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pj-dbtn');
    if (b) {
      e.preventDefault();
      if (!cal.hidden && b.classList.contains('je-open')) calZavri(); else calOtevri(b);
      return;
    }
    if (!cal.hidden && !e.target.closest('.pj-cal')) calZavri();
  });
  cal.addEventListener('click', function (e) {
    e.stopPropagation(); /* po překreslení měsíce by klik vypadal jako „mimo kalendář" a zavřel ho */
    var k = e.target.closest('[data-k]');
    if (k) { calMes = new Date(calMes.getFullYear(), calMes.getMonth() + (+k.dataset.k), 1); calKresli(); return; }
    var d = e.target.closest('[data-v]');
    if (!d) return;
    if (d.dataset.duvod) { calBublina(d); return; }
    var inp = document.getElementById('pj-' + calPole);
    inp.value = d.dataset.v;
    calZavri();
    inp.dispatchEvent(new Event('change'));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cal.hidden) calZavri(); });

  /* ---------- příslušenství: vozík (všude), kufry (jen stroje s kufry), dětská výstroj (jen dětské stroje) ---------- */
  function maKufry() { return mbStroje().some(function (x) { return x.b.kufry; }); }
  function maDetske() { return mbStroje().some(function (x) { return x.b.s === 'deti'; }); }
  function zaskrtnute(sel) { return [].filter.call(koren.querySelectorAll(sel), function (c) { return c.checked; }); }
  [].forEach.call(koren.querySelectorAll('[data-pj-x], .pj-kalk__detska'), function (c) { c.addEventListener('change', prepocti); });
  function kufrNahled() {
    var el = document.getElementById('pj-kufry-nahled');
    if (!el || !D.kufryVzor) return;
    var b = null;
    mbStroje().forEach(function (x) { if (!b && x.b.kufry && x.b.km) b = x.b; });
    if (!b) { el.hidden = true; return; }
    var bo = !!koren.querySelector('[data-pj-x="kufr-bocni"]:checked'), tp = !!koren.querySelector('[data-pj-x="kufr-top"]:checked');
    var stav = bo && tp ? 'obe' : bo ? 'bocni' : tp ? 'top' : 'nic';
    el.hidden = false;
    el.querySelector('img').src = D.kufryVzor.replace('{m}', b.km).replace('{k}', stav);
    var pop = el.querySelector('small');
    if (pop) pop.textContent = 'Náhled s vybranými kufry · ' + b.n;
  }

  /* ---------- přepočet ---------- */
  function prepocti() {
    kresliMB();
    var kufry = maKufry(), detske = maDetske();
    [].forEach.call(koren.querySelectorAll('[data-pj-only="kufry"]'), function (el) {
      el.hidden = !kufry;
      if (!kufry) [].forEach.call(el.querySelectorAll('input'), function (i) { i.checked = false; });
    });
    var kidsEl = document.getElementById('pj-kidsw');
    if (kidsEl) {
      kidsEl.hidden = !detske;
      if (!detske) [].forEach.call(kidsEl.querySelectorAll('input'), function (i) { i.checked = false; });
    }

    var d = delka(), n = pocetDni(), dni = n;
    var radky = [], celkem = 0;
    var popis = d === 'den' ? 'Půjčení na 1 den' : d === 'vikend' ? 'Víkend (pá–po)' : 'Půjčení na ' + dnyTxt(n);
    var MBx = mbStroje(), vic = MBx.length > 1 || (MBx.length === 1 && MBx[0].r.ks > 1);
    function cena(b) { return d === 'den' ? +b.d : d === 'vikend' ? +b.w : +b.d * n; }
    var zaklad = 0;
    MBx.forEach(function (x) {
      var v = cena(x.b) * x.r.ks;
      zaklad += v;
      radky.push([vic ? x.b.n + (x.r.ks > 1 ? ' ×' + x.r.ks : '') + ', ' + popis.replace('Půjčení na ', '').toLowerCase() : popis, v, '']);
    });
    celkem += zaklad;
    if (d === 'vice') {
      var r = sleva(n);
      if (r) {
        var sl = -Math.round(zaklad * r);
        radky.push(['Sleva za více dní −' + Math.round(r * 100) + ' %', sl, 'je-sleva']);
        celkem += sl;
      }
    }
    var setu = 0;
    MBx.forEach(function (x) {
      var k = x.i === 0 ? (x.r.set ? x.r.ks - 1 : 0) : (x.r.set ? x.r.ks : 0);
      if (k) {
        var v = SETP * dni * k;
        setu += k;
        radky.push(['Set výstroje ×' + k + ' k ' + x.b.n + ', ' + dnyTxt(dni), v, '']);
        celkem += v;
      }
    });
    var cv = cenaVystroje();
    if (cv.celySet) {
      var vs = SETP * dni;
      radky.push(['Celý set výstroje ×' + dnyTxt(dni), vs, '']);
      celkem += vs;
    } else {
      vybrano.forEach(function (id) {
        var v = cenaKusu(id) * dni;
        radky.push([nazevKusu(id) + ' ×' + dnyTxt(dni), v, '']);
        celkem += v;
      });
    }
    var detskeKusy = zaskrtnute('.pj-kalk__detska');
    detskeKusy.forEach(function (c) {
      var v = cenaKusu(c.value) * dni;
      radky.push([nazevKusu(c.value) + ' ×' + dnyTxt(dni), v, '']);
      celkem += v;
    });
    var doplnky = zaskrtnute('[data-pj-x]').map(function (c) { return doplnek(c.dataset.pjX); }).filter(Boolean);
    var kauceNavic = 0;
    doplnky.forEach(function (x) {
      var v = (d === 'vikend' && +x.pw) ? +x.pw : +x.p * dni;
      radky.push([x.n + (d === 'vikend' && +x.pw ? ' (víkend)' : ' ×' + dnyTxt(dni)), v, '']);
      celkem += v;
      kauceNavic += +x.kauce || 0;
    });
    var kauce = MBx.reduce(function (a, x) { return a + (+x.b.k) * x.r.ks; }, 0) + kauceNavic;

    document.getElementById('pj-kalk-tab').innerHTML = radky.map(function (r) {
      return '<tr class="' + r[2] + '"><td>' + esc(r[0]) + '</td><td>' + (r[1] < 0 ? '−' + kc(-r[1]) : kc(r[1])) + ' Kč</td></tr>';
    }).join('');
    document.getElementById('pj-kalk-celkem').textContent = kc(celkem) + ' Kč';
    document.getElementById('pj-kalk-kauce').textContent = '+ vratná kauce ' + kc(kauce) + ' Kč v hotovosti';
    kufrNahled();

    /* souhrn výstroje */
    var gs = document.getElementById('pj-gear-souhrn');
    if (!vybrano.length) gs.innerHTML = 'Zatím bez výstroje.';
    else if (cv.celySet) gs.innerHTML = '<b>Celý set: ' + kc(cv.set) + ' Kč / den</b> · ušetříte ' + kc(cv.jednotlive - cv.set) + ' Kč';
    else gs.innerHTML = 'Vybráno ' + vybrano.length + ' ' + (vybrano.length === 1 ? 'kus' : vybrano.length < 5 ? 'kusy' : 'kusů') +
      ': <b>' + kc(cv.zaDen) + ' Kč / den</b>' +
      (cv.jednotlive >= cv.set ? ' <span class="pj-upsell">· celý set vyjde ' + (cv.jednotlive === cv.set ? 'stejně' : 'levněji (' + kc(cv.set) + ' Kč)') + '</span>' : '');
    document.getElementById('pj-gear-set').hidden = cv.celySet;
    document.getElementById('pj-gear-zrus').hidden = !vybrano.length;

    /* přenos do poptávky */
    var terminTxt = '';
    if (polOd.value || polDo.value) {
      var dn = (polOd.value && polDo.value) ? Math.round((new Date(polDo.value) - new Date(polOd.value)) / 864e5) : 0;
      terminTxt = (fmtD(polOd.value) || '?') + ' – ' + (fmtD(polDo.value) || '?') + (dn > 0 ? ' (' + dnyTxt(dn) + ')' : '');
    }
    var termEl = document.getElementById('pj-f-termin');
    termEl.innerHTML = terminTxt ? '<b>' + terminTxt + '</b>' :
      '<span class="pj-napoveda">Zatím nevybraný. <a href="#kalkulacka">Vyberte ho v kalkulačce</a>, nebo ho napište do zprávy.</span>';
    var sestava = (terminTxt ? 'Termín: ' + terminTxt + '\n' : '') +
      'Motorky: ' + mbText() + '\n' +
      radky.map(function (r) { return r[0] + ': ' + (r[1] < 0 ? '−' + kc(-r[1]) : kc(r[1])) + ' Kč'; }).join('\n') +
      '\nCelkem orientačně: ' + kc(celkem) + ' Kč + kauce ' + kc(kauce) + ' Kč';
    document.getElementById('pj-f-sestava').textContent = sestava;
    document.getElementById('pj-h-sestava').value = sestava;
    document.getElementById('pj-h-termin').value = terminTxt || '(nevybráno)';
    document.getElementById('pj-h-motorka').value = mbText();
    document.getElementById('pj-h-delka').value = popis;
    document.getElementById('pj-h-vystroj').value = (cv.celySet ? 'celý set' :
      (vybrano.length ? vybrano.map(nazevKusu).join(', ') : 'bez výstroje')) +
      (detskeKusy.length ? ' + ' + detskeKusy.map(function (c) { return nazevKusu(c.value); }).join(', ') : '') +
      (setu ? ' + set pro další jezdce ×' + setu : '');
    document.getElementById('pj-h-prislusenstvi').value = doplnky.length ? doplnky.map(function (x) { return x.n; }).join(', ') : 'nic';
    document.getElementById('pj-h-cena').value = kc(celkem) + ' Kč (orientačně) · kauce ' + kc(kauce) + ' Kč';
    document.getElementById('pj-velikosti').hidden = !(vybrano.length || detskeKusy.length || setu);
  }

  /* ---------- kontrola poptávky ---------- */
  var form = document.getElementById('pujcovna-poptavka');
  if (form) {
    form.addEventListener('submit', function (e) {
      var chyba = document.getElementById('pj-f-chyba');
      function stop(t) { e.preventDefault(); chyba.textContent = t; }
      var chybi = ['contact[name]', 'contact[phone]', 'contact[email]'].filter(function (n) {
        var el = form.querySelector('[name="' + n + '"]');
        return el && !el.value.trim();
      });
      if (chybi.length) return stop('Vyplňte prosím jméno, telefon a e-mail.');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.querySelector('[name="contact[email]"]').value.trim())) return stop('Zkontrolujte prosím e-mail.');
      if (!document.getElementById('pj-souhlas').checked) return stop('Potvrďte prosím souhlas se zpracováním údajů.');
      var hp = form.querySelector('[name="web"]');
      if (hp && hp.value) return stop('Formulář se nepodařilo odeslat.');
      var tch = terminChyby();
      if (tch.length) {
        vykresliTermin();
        stop('Zkontrolujte prosím termín v kalkulačce: ' + tch[0]);
        document.getElementById('kalkulacka').scrollIntoView({ block: 'start', behavior: 'smooth' });
        return;
      }
      chyba.textContent = '';
    });
  }

  vykresliTermin();
  prepocti();
})();
